import React, { Suspense, lazy } from "react";
import PropTypes from "prop-types";
import { Route, Switch, withRouter } from "react-router-dom";

// components
import NotFound from "../_common/notFound/NotFound";
import ScrollToTop from "../_common/scrollToTop/ScrollToTop";
import CustomRoutes from "./CustomRoutes";

// error
import BlankScreen from "../_common/blankScreen/blankScreen";
import { DmOrderDetails } from "../_pages/_transactions/direct-mail/components/DmOrderDetails";
import ShopOrderDetails from "../_pages/_transactions/shop/ShopOrderDetails";

const HomePage = lazy(() => import("../_pages/_homepage/HomePage"));
const TransactionsInfo = lazy(() => import("../_pages/_transactions/click-and-post/TransactionInfo"));

const Routes = ({ history }) => {
    return (
        <ScrollToTop>
            <Suspense fallback={<BlankScreen />}>
                <Switch>
                    {/* Root of the app display, display different component based on the path that's set in the url */}
                    {/** Overview */}
                    <Route exact path={["/", "/myAccount", "/Business"]} component={() => <HomePage history={history} openTab="overview" />} />

                    {/** Profile */}
                    <Route exact path="*/profile" component={() => <HomePage history={history} openTab="profile" />} />

                    {/** Marketing Preferences */}
                    <Route exact path="*/profile/marketingPreferences" component={() => <HomePage history={history} openTab="profile" profileTab="marketing" />} />

                    {/** Addresses */}
                    <Route exact path="*/addresses" component={() => <HomePage history={history} openTab="addresses" />} />

                    {/** TRANSACTIONS */}
                    <Route exact path="*/transactions" component={() => <HomePage history={history} openTab="cnp" />} />

                    {/** Transactions details */}
                    <Route path="*/Transactions/transaction-info" component={TransactionsInfo} />

                    <Route path="*/Transactions/dm" component={DmOrderDetails} />

                    <Route path="*/Transactions/shop" component={ShopOrderDetails} />

                    {/** Custom Routes */}
                    <CustomRoutes history={history} />

                    {/** GLOBAL HELPERS */}
                    {/** session expired */}
                    <Route exact path="/session-expired" component={() => <NotFound history={history} />} />

                    {/** session expired */}
                    <Route component={() => <NotFound history={history} error />} />
                </Switch>
            </Suspense>
        </ScrollToTop>
    );
};

export default withRouter(Routes);

// props validation
Routes.propTypes = {
    history: PropTypes.object
};
